export const API_ENDPOINTS = {
    NAMELIST_CUSTOMER: ({ customerNumber }) =>
        `/apps/store/api/v1.1/customers/${customerNumber}/namelist-customer`,
    NAMELIST_VERIFICATION: ({ customerNumber, consumerId }) =>
        `/apps/store/api/v1.1/customers/${customerNumber}/namelist-verification/${consumerId}`,
}